// AddCompany.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config/serverApiConfig";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import styles from "./addCompanyStyles.module.css";

function AddCompany() {
  // State Hooks
  const [companyName, setCompanyName] = useState("");
  const [adminFirstName, setAdminFirstName] = useState("");
  const [adminLastName, setAdminLastName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const adminType = "2";

  // Email Validation
  const isValidEmail = (email) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  // ─────────── phone formatter ───────────
  const handlePhoneChange = (e) => {
    let digits = e.target.value.replace(/\D/g, "").substring(0, 10);
    let formatted = digits;
    if (digits.length > 6) {
      formatted = `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
    } else if (digits.length > 3) {
      formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
    }
    setContactPhone(formatted);
  };

  // Validate Form
  const validateForm = () => {
    const errors = {};

    if (!companyName.trim())           errors.companyName    = "Company Name is required";
    if (!adminFirstName.trim())        errors.adminFirstName = "First Name is required";
    if (!adminLastName.trim())         errors.adminLastName  = "Last Name is required";

    if (!contactPhone.trim())          errors.contactPhone   = "Contact Phone is required";
    else if (!/^\d{3}-\d{3}-\d{4}$/.test(contactPhone))
                                       errors.contactPhone   = "Invalid phone number (123-456-7890)";

    if (!adminEmail.trim())            errors.adminEmail     = "Email is required";
    else if (!isValidEmail(adminEmail))errors.adminEmail     = "Invalid email format";

    if (!adminPassword.trim())         errors.adminPassword  = "Password is required";
    if (!imageFile)                    errors.imageFile      = "Image is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Clear Form
  const clearForm = () => {
    setCompanyName("");
    setAdminFirstName("");
    setAdminLastName("");
    setContactPhone("");
    setAdminEmail("");
    setAdminPassword("");
    setImageFile(null);
    setImageUrl(null);
    setFormErrors({});
    setErrorMessage("");
    setSuccessMessage("");
  };

  // Handle File Change
  // const handleFileChange = async (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (!selectedFile) return;

  //   if (selectedFile.size > 1024 * 1024) {
  //     setFormErrors((prev) => ({
  //       ...prev,
  //       imageFile: "Image size should be less than 1MB",
  //     }));
  //     return;
  //   }

  //   setImageFile(selectedFile.name);
  //   const reader = new FileReader();
  //   reader.onload = (ev) => setImageUrl(ev.target.result);
  //   reader.readAsDataURL(selectedFile);

  //   const formData = new FormData();
  //   formData.append("file", selectedFile);
  //   try {
  //     await axios.post("https://starbehaviors.com/uploadimage.php", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //   } catch (err) {
  //     console.error("Image upload failed", err);
  //     setFormErrors((prev) => ({
  //       ...prev,
  //       imageFile: "Image upload failed",
  //     }));
  //   }
  // };


  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
  
    if (selectedFile.size > 1024 * 1024) {
      setFormErrors((prev) => ({
        ...prev,
        imageFile: "Image size should be less than 1MB",
      }));
      return;
    }
  
    setImageFile(selectedFile.name);
    const reader = new FileReader();
    reader.onload = (ev) => setImageUrl(ev.target.result);
    reader.readAsDataURL(selectedFile);
  
    const formData = new FormData();
    formData.append("file", selectedFile);
  
    try {
      const response = await axios.post("https://starbehaviors.com/uploadimage.php", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      // Inspect and log response
      console.log("Upload response:", response.data);
  
      if (
        response.status === 200 &&
        (response.data.success || typeof response.data === "string" || response.data.includes("Success"))
      ) {
        // upload is successful — clear previous error if any
        setFormErrors((prev) => ({ ...prev, imageFile: undefined }));
      } else {
        // upload succeeded but response is unexpected
        setFormErrors((prev) => ({
          ...prev,
          imageFile: "Unexpected upload response",
        }));
      }
    } catch (err) {
      console.error("Image upload failed", err);
      setFormErrors((prev) => ({
        ...prev,
        imageFile: "Image upload failed",
      }));
    }
  };
  
  // Handle Save
  const handleSave = async () => {
    if (!validateForm()) return;

    const dataToSend = {
      companyName,
      adminid: "",
      adminemail: adminEmail,
      admin_first_name: adminFirstName,
      admin_last_name: adminLastName,
      contactPhone,
      admin_type: adminType,
      admin_password: adminPassword,
      imageFile: imageFile || "",
      admin_site_url: "",
      adminemails: "",
      adminpageheader: "",
      adminpagecontent: "",
      adminemailadminpageoffers: "",
      adminpagecta: "",
      assessmentRecipient: "",
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/sb_addeditcompanyuser`,
        dataToSend,
        { headers: { "Content-Type": "application/json" } }
      );

      if (
        response.data.Message ===
        "User with the following email address already exists"
      ) {
        setErrorMessage("Company with this email address already exists.");
        setSuccessMessage("");
      } else if (response.data.Message === "User Login User type: 2") {
        setSuccessMessage("Company added successfully");
        setErrorMessage("");
        setShowModal(true);
      } else {
        setErrorMessage("Unexpected response: " + response.data.Message);
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("An error occurred while saving the form.");
      setSuccessMessage("");
    }
  };

  // Navigate after success
  useEffect(() => {
    let timer;
    if (showModal) {
      timer = setTimeout(() => navigate("/admin/view-company"), 1500);
    }
    return () => clearTimeout(timer);
  }, [showModal, navigate]);

  return (
    <div className={styles.formContainer}>
      <h2>Add company</h2>
      {successMessage && <div className={styles.successMessage}>{successMessage}</div>}

      <form className={styles.assignForm}>
        <div className={styles.formRow}>
          <input
            type="text"
            placeholder="Company Name*"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            className={formErrors.companyName ? styles.errorInput : styles.selectField}
          />
          {formErrors.companyName && <div className={styles.errorMessage}>{formErrors.companyName}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="text"
            placeholder="First Name*"
            value={adminFirstName}
            onChange={(e) => setAdminFirstName(e.target.value)}
            className={formErrors.adminFirstName ? styles.errorInput : styles.selectField}
          />
          {formErrors.adminFirstName && <div className={styles.errorMessage}>{formErrors.adminFirstName}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="text"
            placeholder="Last Name*"
            value={adminLastName}
            onChange={(e) => setAdminLastName(e.target.value)}
            className={formErrors.adminLastName ? styles.errorInput : styles.selectField}
          />
          {formErrors.adminLastName && <div className={styles.errorMessage}>{formErrors.adminLastName}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="tel"
            placeholder="123-456-7890"
            value={contactPhone}
            onChange={handlePhoneChange}
            pattern="\d{3}-\d{3}-\d{4}"
            className={formErrors.contactPhone ? styles.errorInput : styles.selectField}
          />
          {formErrors.contactPhone && <div className={styles.errorMessage}>{formErrors.contactPhone}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="email"
            placeholder="Email*"
            value={adminEmail}
            onChange={(e) => setAdminEmail(e.target.value)}
            className={formErrors.adminEmail ? styles.errorInput : styles.selectField}
          />
          {formErrors.adminEmail && <div className={styles.errorMessage}>{formErrors.adminEmail}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="password"
            placeholder="Password*"
            value={adminPassword}
            onChange={(e) => setAdminPassword(e.target.value)}
            className={formErrors.adminPassword ? styles.errorInput : styles.selectField}
          />
          {formErrors.adminPassword && <div className={styles.errorMessage}>{formErrors.adminPassword}</div>}
        </div>

        <div className={styles.formRow}>
          <input
            type="file"
            onChange={handleFileChange}
            className={formErrors.imageFile ? styles.errorInput : styles.selectField}
          />
          {formErrors.imageFile && <div className={styles.errorMessage}>{formErrors.imageFile}</div>}
          {imageUrl && <img src={imageUrl} alt="Company Logo" className={styles.logoPreview} />}
        </div>

        {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}

        <div className={styles.buttonContainer}>
          <button type="button" onClick={handleSave} className={styles.submitButton}>
            Save
          </button>
          <button type="button" onClick={clearForm} className={styles.submitButton} style={{ backgroundColor: "red" }}>
            Clear
          </button>
        </div>
      </form>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Company created successfully</Modal.Body>
      </Modal>
    </div>
  );
}

export default AddCompany;
